import Layout from "../cponents/layout";
import useAuthUser from "../hooks/useAuthUser";
import { useEffect, useState } from "react";
import BaseEndpoint from "../endpoints/baseEndpoint";
import Potential from "./dashboard/potential";
import Grid from "./dashboard/grid";

export default function Dashboard() {
    const { user } = useAuthUser();

    const [answer, setAnswer] = useState(null);
    const [expired, setExpired] = useState(false);
    useEffect(() => {
        BaseEndpoint.instance().get(`/exam/${user.version}/answer?token=${user.token}`).then((response) => {
            if (response.status === 200) {
                setAnswer(response.data.exists);
                setExpired(response.data.expired);
            }
        });
    }, []);

    return (
        <Layout>
            <div className="container mx-auto py-5" style={{ minHeight: "80vh" }}>
                {[
                    'tes-akademik',
                    'spesial-potential-test'
                ].includes(user?.version) ? <Grid
                                                user={user}
                                                answer={answer} /> 
                                            : <Potential
                                                user={user}
                                                answer={answer}
                                                disabled={expired} /> 
                                            || 'Memuat...'}
            </div>
        </Layout>
    );
}